import AppontmentCardContainer from "./AppointmentCardContainer";
export default AppontmentCardContainer;